import { render, staticRenderFns } from "./NotRegistered.vue?vue&type=template&id=22552655"
import script from "./NotRegistered.vue?vue&type=script&lang=js"
export * from "./NotRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports